import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"

import {Page} from "@indebted/components/Page"
import {InvalidCodeImage} from "@indebted/assets"

function Invalid() {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					Unexpected result
				</Typography>
			</Grid>

			<GridImage>
				<InvalidCodeImage />
			</GridImage>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {Invalid}
